export enum SessionStorageKeys {
    OKTA_AUTH_ACCESS_TOKEN = 'okta-auth-access-token',
    OKTA_AUTH_EMAIL = 'okta-auth-email',
}
